/**
 * 当前浏览器窗口高度,宽度
 */
const WINDOW_HEIGHT =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

const WINDOW_WIDTH =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

/**
 * 默认的UpmsResource资源菜单ICON图标
 */
const DEFAULT_UPMS_RESOURCE_ICON = 'fas fa-dot';

/**
 * 页头高度
 */
const ADMIN_HEADER_HEIGHT = 60;

/**
 * 后台管理all-in-one数据接口加载超时时间
 */
const ADMIN_ALL_DATA_LOADING_TIMEOUT = 1000;

/**
 * 页面加载组件vue-progressbar的颜色
 */
const ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR = '#00A65A';

/**
 * 页面加载组件vue-progressbar加载失败时的颜色
 */
const ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR_FAIL = '#bc0f0f';

/**
 * 后台管理首页URL
 */
const ADMIN_INDEX_URL = '/index.html';

/**
 * 后台管理登录页URL
 */
const ADMIN_LOGIN_URL = '/login.html';

/**
 * 后台管理注册页URL
 */
const ADMIN_REGISTER_URL = '/register.html';

export {
    WINDOW_HEIGHT,
    WINDOW_WIDTH,
    DEFAULT_UPMS_RESOURCE_ICON,
    ADMIN_HEADER_HEIGHT,
    ADMIN_ALL_DATA_LOADING_TIMEOUT,
    ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR,
    ADMIN_PAGE_LOADING_PROGRESSBAR_COLOR_FAIL,
    ADMIN_INDEX_URL,
    ADMIN_LOGIN_URL,
    ADMIN_REGISTER_URL
};